import { Product } from '@/interfaces/catalog/Product'
import { Sku } from '@/interfaces/catalog/Sku'

export const ALL_SKUS_TAB = 'all'

export const formatProductSkuLabel = (
  productName: string,
  skuName?: string | null,
): string => {
  if (skuName && skuName !== productName) {
    return `${productName}, ${skuName}`
  }
  return productName
}

// API returns options in arbitrary order and SKU option label holds the value, so use the product's axes for order and labels.
export const formatSkuOptions = (sku: Sku, product?: Product): string =>
  [...(product?.variantAxes ?? [])]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .flatMap(({ axisId, axis }) => {
      const option = sku.options?.find((o) => o.axisId === axisId)
      return option ? [axis.values.find((v) => v.id === option.valueId)?.label ?? option.label] : []
    })
    .join(', ') || sku.name

export const getSystemSku = (skus: Sku[]) => skus.find((s) => s.isSystem)

export const getUserSkus = (skus: Sku[]) => skus.filter((s) => !s.isSystem)

export const resolveActiveSkuId = (
  skus: Sku[],
  selectedUserSkuId?: string,
): string | undefined => {
  const userSkus = getUserSkus(skus)

  if (userSkus.length > 0) {
    if (selectedUserSkuId && userSkus.some((sku) => sku.id === selectedUserSkuId)) {
      return selectedUserSkuId
    }
    return userSkus[0]?.id
  }

  return getSystemSku(skus)?.id
}

// A single variant behaves as no variant, so its price belongs to the system SKU.
export const resolvePriceSkuId = (
  skus: Sku[],
  selectedTab: string,
): string | undefined => {
  if (selectedTab === ALL_SKUS_TAB || getUserSkus(skus).length <= 1) {
    return getSystemSku(skus)?.id ?? resolveActiveSkuId(skus, selectedTab)
  }

  return resolveActiveSkuId(skus, selectedTab)
}
